import React from 'react'
import { useStoreState } from 'store'

const SelectText = () => {
  const flags = useStoreState(state => state.featureFlags.flags)
  const hideBrSelectText = flags['hideBrSelectText']
  if (hideBrSelectText) {
    return null
  }
  return (
    <div className="selection-description">
      <p className="text-slate type-body-two pt-4 pb-4 md:pb-8 mb-0" data-testid="selection-description">
        {flags['brSelectDescriptionText'] as string}
      </p>
    </div>
  )
}

export default SelectText
